import { Link, NavLink } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";

const navLinkClass = ({ isActive }) =>
  `public-nav-link ${isActive ? "public-nav-link-active" : ""}`;

export default function PublicLayout({ children }) {
  const { status, user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const accountPath =
    status === "authed" ? (user?.role === "danisan" ? "/danisan-paneli" : "/yonetim") : "/giris";
  const accountLabel =
    status === "authed"
      ? user?.role === "danisan"
        ? "Danışan paneli"
        : "Yönetim paneli"
      : "Giriş yap";

  return (
    <div className="public-site">
      <a href="#public-main" className="public-skip-link">
        İçeriğe geç
      </a>
      <header className="public-header">
        <div className="public-shell public-header-inner">
          <Link to="/" className="public-brand" aria-label="Pleiades Rehberlik ana sayfa">
            <span>
              <strong>Pleiades Rehberlik</strong>
            </span>
          </Link>
          <nav className="public-desktop-nav" aria-label="Ana navigasyon">
            <NavLink to="/" end className={navLinkClass}>
              Ana sayfa
            </NavLink>
            <NavLink to="/danismanlik" className={navLinkClass}>
              Danışmanlık
            </NavLink>
            <Link to={accountPath} className="public-header-action">
              {accountLabel}
              <ArrowRight size={16} aria-hidden="true" />
            </Link>
          </nav>
          <button
            type="button"
            className="public-menu-toggle"
            aria-expanded={menuOpen}
            aria-controls="public-mobile-menu"
            onClick={() => setMenuOpen((current) => !current)}
          >
            <span className="sr-only">{menuOpen ? "Menüyü kapat" : "Menüyü aç"}</span>
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
        {menuOpen && (
          <nav id="public-mobile-menu" className="public-mobile-nav" aria-label="Mobil navigasyon">
            <NavLink to="/" end className={navLinkClass} onClick={() => setMenuOpen(false)}>
              Ana sayfa
            </NavLink>
            <NavLink to="/danismanlik" className={navLinkClass} onClick={() => setMenuOpen(false)}>
              Danışmanlık
            </NavLink>
            <Link
              to={accountPath}
              className="public-header-action"
              onClick={() => setMenuOpen(false)}
            >
              {accountLabel}
              <ArrowRight size={16} aria-hidden="true" />
            </Link>
          </nav>
        )}
      </header>
      <main id="public-main">{children}</main>
      <footer className="public-footer">
        <div className="public-shell public-footer-inner">
          <div>
            <strong>Pleiades Rehberlik</strong>
            <p>
              Şeref Tolga Kuralay tarafından hazırlanan ve takip edilen kişisel meditasyon
              çalışmaları.
            </p>
          </div>
          <div className="public-footer-links">
            <Link to="/danismanlik">Danışmanlık programları</Link>
            <Link to="/kvkk-aydinlatma-metni">KVKK Aydınlatma Metni</Link>
            <Link to={accountPath}>{accountLabel}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
